<template>
  <div class="focus-keywords">
    <div class="row focus-keywords-content">
      <div class="focus-keywords-content-left">
        <div class="focus-keywords-content-left-table">
          <div>
            <el-button class="concern-btn" @click="onAddConcernKeywords">添加关注关键词</el-button>
          </div>
          <div class="body">
            <el-table
              :data="keywordData"
            > 
              <el-table-column
                label="关键词"
                width="180"
                >
                <template slot="header" slot-scope="scope">
                  <div @onScope="scope">
                    <div class="header-title">关键词</div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div class="title-name">{{scope.row.keyword}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="条件"
                >
                <template slot="header" slot-scope="scope">
                  <div @onScope="scope">
                    <div class="header-title">条件</div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div class="title-name">{{scope.row.match}}</div>
                </template>
              </el-table-column>
              <el-table-column width="76px" label="操作">
                <template slot="header" slot-scope="scope">
                  <div @onScope="scope">
                    <div class="header-title">操作</div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div class="operation-class">
                    <el-tooltip 
                      class="item" 
                      effect="dark" 
                      content="编辑分组" 
                      :visible-arrow="false"
                      :enterable="false"
                      popper-class="tip"
                      placement="bottom-start"
                    >
                      <i class="edit" @click="onEditBtnClick(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip 
                      class="item" 
                      effect="dark" 
                      content="取消关注" 
                      :visible-arrow="false"
                      :enterable="false"
                      popper-class="tip"
                      placement="bottom-start"
                    >
                      <i class="delete" @click="onDeleteBtnClick(scope.row)"></i>
                    </el-tooltip>
                </div>
              </template>
            </el-table-column>
            </el-table>
          </div>
          <div class="pager" v-if="totalCount > pageSize">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="totalCount">
              </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title='取消关注'
      class="delete-dialog"
      :visible.sync="dialogVisible"
      width="400px"
      top="30vh"
    >
    <div class="content">取消关注“{{ keywordName }}”？</div>
      <div class="footer" slot="footer" >
        <div class="footer-btn">
          <el-button class="cancel-btn" @click="onCancelClick">取消</el-button>
          <el-button class="confirm-btn" @click="onOKDeleteBtnClick">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <div class="add-keywords-dialog">
      <el-dialog
        :visible.sync="addKeywordsDialogVisible"
        width="352"
        :close-on-click-modal=false
        top="23vh"
        :before-close="addKeywordsHandleClose"
        >
        <div class="add-keywords-dialog_title">{{dialogTitleName}}</div>
        <div class="keyword-news-list-box">
          <div class="add-keywords-input">
            <div class="add-keywords-input-title">名称<span class="mandatory-symbols">*</span></div>
            <div class="add-keywords-input-content">
              <el-input 
                ref="input" 
                type="text" 
                :placeholder="'组合名称(20字内)'" 
                v-model.trim="keyword"
                maxlength="20"
                show-word-limit
              ></el-input>
            </div>
            <div class="add-keywords-input-title">标题关键词</div>
            <div class="add-keywords-textarea">
              <el-input
                type="textarea"
                resize="none"
                placeholder="关键词之间用空格隔开" 
                :autosize="{ minRows: 1 }"
                v-model="titleAllMatch">
              </el-input>
              <div class="add-keywords-textarea-content">
                匹配全部
              </div>
              <div class="add-keywords-textarea-content-border">|</div>
            </div>
            <div class="add-keywords-textarea">
              <el-input
                type="textarea"
                resize="none"
                placeholder="关键词之间用空格隔开" 
                :autosize="{ minRows: 1 }"
                v-model="titleSingleMatch">
              </el-input>
              <div class="add-keywords-textarea-content">
                至少匹配一个
              </div>
              <div class="add-keywords-textarea-content-border">|</div>
            </div>
            <div class="add-keywords-textarea">
              <el-input
                type="textarea"
                resize="none"
                placeholder="关键词之间用空格隔开" 
                :autosize="{ minRows: 1 }"
                v-model="titleNotMatch">
              </el-input>
              <div class="add-keywords-textarea-content">
                不匹配全部
              </div>
              <div class="add-keywords-textarea-content-border">|</div>
            </div>


            <div class="add-keywords-input-title">正文关键词</div>
            <div class="add-keywords-textarea">
              <el-input
                type="textarea"
                resize="none"
                placeholder="关键词之间用空格隔开" 
                :autosize="{ minRows: 1 }"
                v-model="contentAllMatch">
              </el-input>
              <div class="add-keywords-textarea-content">
                匹配全部
              </div>
              <div class="add-keywords-textarea-content-border">|</div>
            </div>
            <div class="add-keywords-textarea">
              <el-input
                type="textarea"
                resize="none"
                placeholder="关键词之间用空格隔开" 
                :autosize="{ minRows: 1 }"
                v-model="contentSingleMatch">
              </el-input>
              <div class="add-keywords-textarea-content">
                至少匹配一个
              </div>
              <div class="add-keywords-textarea-content-border">|</div>
            </div>
            <div class="add-keywords-textarea">
              <el-input
                type="textarea"
                resize="none"
                placeholder="关键词之间用空格隔开" 
                :autosize="{ minRows: 1 }"
                v-model="contentNotMatch">
              </el-input>
              <div class="add-keywords-textarea-content">
                不匹配全部
              </div>
              <div class="add-keywords-textarea-content-border">|</div>
            </div>
          </div>
          <div class="add-keywords-div"></div>
          <div class="add-keywords-btn">
            <el-button class="cancel-add-keywords-btn" @click="onCancelAddKeywordsBtn">取消</el-button>
            <el-button v-if="keyword && (titleAllMatch || titleSingleMatch || contentAllMatch || contentSingleMatch)" class="add-keywords-next-btn" :loading="onAddKeywordsBtnLoading" @click="onAddKeywordsBtn">添加</el-button>
            <el-button v-else class="no-add-keywords-next-btn">添加</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>  
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      dialogTitleName: '添加关注关键词',
      pageNum: 1,
      pageSize: 20,
      totalCount: 0,
      type: 'add',
      keywordId: -1,
      keywordName: '',
      keywordData: [],
      keyword: '',
      titleAllMatch: '',
      titleSingleMatch: '',
      titleNotMatch: '',
      contentAllMatch: '',
      contentSingleMatch: '',
      contentNotMatch: '',
      onAddKeywordsBtnLoading: false,
      addKeywordsDialogVisible: false,
      username: '',
      industryTags: [],
      dialogVisible: false,
      addIndustryDialogVisible: false,
      industryName: '',
      industryData: [],
      dialogIndustrySelectedTags: []
    };
  },
  methods: {
    onAddConcernKeywords() {
      this.dialogTitleName = '添加关注关键词';
      this.type = 'add';
      this.keyword = '';
      this.titleAllMatch = '';
      this.titleSingleMatch = '';
      this.titleNotMatch = '';
      this.contentAllMatch = '';
      this.contentSingleMatch = '';
      this.contentNotMatch = '';
      this.addKeywordsDialogVisible = true;
    },
    addKeywordsHandleClose() {
      this.addKeywordsDialogVisible = false;
    },
    onCancelAddKeywordsBtn() {
      this.addKeywordsDialogVisible = false;
      this.keyword = '';
      this.titleAllMatch = '';
      this.titleSingleMatch = '';
      this.titleNotMatch = '';
      this.contentAllMatch = '';
      this.contentSingleMatch = '';
      this.contentNotMatch = '';
    },
    onAddKeywordsBtn() {
      if (this.type === 'add') {
        const params = {
          user: this.username,
          keyword: this.keyword,
          title_all_match: this.titleAllMatch,
          title_single_match: this.titleSingleMatch,
          title_not_match: this.titleNotMatch,
          content_all_match: this.contentAllMatch,
          content_single_match: this.contentSingleMatch,
          content_not_match: this.contentNotMatch
        };
        QuestionQuery.getMonitorKeyword(params).then(() => {
          this.addKeywordsDialogVisible = false;
          this.getMonitorKeywordList();
        });
      } else if (this.type === 'change') {
        const params = {
          user: this.username,
          id: this.keywordId,
          keyword: this.keyword,
          title_all_match: this.titleAllMatch,
          title_single_match: this.titleSingleMatch,
          title_not_match: this.titleNotMatch,
          content_all_match: this.contentAllMatch,
          content_single_match: this.contentSingleMatch,
          content_not_match: this.contentNotMatch
        };
        QuestionQuery.putMonitorKeyword(params).then(() => {
          this.addKeywordsDialogVisible = false;
          this.getMonitorKeywordList();
        });
      }
    },
    onEditBtnClick(res) {
      this.dialogTitleName = '编辑关注关键词';
      this.type = 'change';
      this.keyword = res.keyword;
      this.keywordId = res.id;
      this.titleAllMatch = res.title_all_match;
      this.titleSingleMatch = res.title_single_match;
      this.titleNotMatch = res.title_not_match;
      this.contentAllMatch = res.content_all_match;
      this.contentSingleMatch = res.content_single_match;
      this.contentNotMatch = res.content_not_match;
      this.addKeywordsDialogVisible = true;
    },
    handleCurrentChange(res) {
      this.pageNum = res;
      this.getMonitorKeywordList();
    },
    getMonitorKeywordList() {
      const params = {
        user: this.username,
        page_num: this.pageNum,
        page_size: this.pageSize
      };
      QuestionQuery.getMonitorKeywordPageList(params).then(res => {
        let titleAllMatchData;
        let titleNotMatchData;
        let titleSingleMatchData;
        let contentAllMatchData;
        let contentSingleMatchData;
        let contentNotMatchData;
        res.page_items.forEach(item => {
          titleAllMatchData = item.title_all_match ? `标题(全部匹配关键词): ${item.title_all_match};   ` : '';
          titleSingleMatchData = item.title_single_match ? `标题(至少匹配一个关键词): ${item.title_single_match};  ` : '';
          titleNotMatchData = item.title_not_match ? `标题(不匹配全部关键词): ${item.title_not_match}; ` : '';
          contentAllMatchData = item.content_all_match ? `正文(全部匹配关键词): ${item.content_all_match};    ` : '';
          contentSingleMatchData = item.content_single_match ? `正文(至少匹配一个关键词): ${item.content_single_match};  ` : '';
          contentNotMatchData = item.content_not_match ? `正文(不匹配全部关键词): ${item.content_not_match};  ` : '';
          item.match = `${titleAllMatchData}${titleSingleMatchData}${titleNotMatchData}${contentAllMatchData}${contentSingleMatchData}${contentNotMatchData}`;
        });
        this.keywordData = res.page_items;
        this.totalCount = res.total_count;
      });
    },
    onDeleteBtnClick(res) {
      this.dialogVisible = true;
      this.keywordName = res.keyword;
      this.keywordId = res.id;
    },
    onCancelClick() {
      this.dialogVisible = false;
    },
    onOKDeleteBtnClick() {
      QuestionQuery.deleteMonitorKeyword(this.keywordId).then(() => {
        this.pageNum = 1;
        this.dialogVisible = false;
        this.getMonitorKeywordList();
      });
    },
    onAddIndustryClick() {
      this.addIndustryDialogVisible = true;
      QuestionQuery.getNewsIndustryTags('industry').then(res => {
        this.industryTags = res.industry;
        this.industryData.forEach(item => {
          this.industryTags.forEach(i => {
            if (item.id === i.id) {
              this.industryTags.splice(this.industryTags.indexOf(i), 1);
            }
          });
        });
      });
    },
    cancelAddIndustryBtnClick() {
      this.dialogIndustrySelectedTags = [];
      this.addIndustryDialogVisible = false;
    },
    confirmAddIndustryBtnClick() {
      QuestionQuery.getAddMonitorIndustry(this.username, this.dialogIndustrySelectedTags).then(() => {
        this.addIndustryDialogVisible = false;
        this.dialogIndustrySelectedTags = [];
        this.getMonitorIndustryList();
      });
    },
    getMonitorIndustryList() {
      QuestionQuery.getMonitorIndustryList(this.username, 1, 100).then(res => {
        this.industryData = res.industry.map(item => {
          return {
            name: item.name,
            id: item.id
          };
        });
      });
    },
    onSelectIndustryTagClick(res) {
      if (this.dialogIndustrySelectedTags.indexOf(res) === -1) {
        this.dialogIndustrySelectedTags.push(res);
      } else {
        this.dialogIndustrySelectedTags.splice(this.dialogIndustrySelectedTags.indexOf(res), 1);
      }
    },
    onDelTag(res) {
      this.dialogIndustrySelectedTags.splice(this.dialogIndustrySelectedTags.indexOf(res), 1);
    }
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getMonitorKeywordList();
  }
};
</script>

<style lang="scss" scoped>
  .focus-keywords {
    &-content {
      &-left {
        width: 1200px;
        min-height: calc(100vh - 134px);
        &-table {
          padding:10px 24px 0;
          .concern-btn {
            height: 26px;
            width: 122px;
            margin: 16px 0;
            padding: 0;
            border-radius: 2px;
            border: none;
            font-size: 14px;
            color: #464d6c;
            background-color: #f7f8fc;
            font-weight: 400;
            &:hover {
              color: #464d6c;
              background-color: #eaebef;
            }
            &:focus {
              color: #464d6c;
              background-color: #eaebef;
            }
            &:active {
              color: #464d6c;
              background-color: #eaebef;
            }
          }
          .body {
            min-height: calc(100vh - 277px);
          }
        }
      } 
      &-right {
        width: 595px;
        height: calc(100vh - 134px);
        background-color: #ffffff;
      }
      .add-btn {
        margin-top: 9px;
        height: 26px;
        width: 143px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #464d6c;
        background-color: #f7f8fc;
        &:hover {
          color: #464d6c;
          background-color: #f7f8fc;
        }
        &:focus {
          color: #464d6c;
          background-color: #f7f8fc;
        }
        &:active {
          color: #464d6c;
          background-color: #f7f8fc;
        }
      }
    }
  }
  .title-name {
    color: #464d6c;
    font-size: 14px;
  }
  .header-title {
    color: #747990;
    font-weight: 400;
  }
  .operation-class {
    display: flex;
    justify-content: space-around;
    .edit {
      display: inline-block;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/edit-icon.svg");
      background-size: 100% 100%;
      align-items: center;
      cursor: pointer;
      &:hover {
        background-image: url("../../assets/img/edit-icon-hover.svg");
      }
    }
    .delete {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-left: 12px;
      background-color: transparent;
      background-image: url("../../assets/img/delete-icon.svg");
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        border-radius: 2px;
        background-image: url("../../assets/img/delete-icon-hover.svg");
      }
    }
    .edit-hover {
      height: 24px;
      padding: 3px 17px 5px 0px;
      &:hover {
        border-radius: 2px;
      }
      &:active {
        border-radius: 2px;
      }
      .edit {
        display: inline-block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        background-color: transparent;
        background-image: url("../../assets/img/edit-icon.svg");
        background-size: 100% 100%;
        align-items: center;
        cursor: pointer;
        &:hover {
          background-image: url("../../assets/img/edit-icon-hover.svg");
        }
      }
    }
    .delete-hover {
      height: 24px;
      padding: 3px 4px 5px 0px;
      &:hover {
        border-radius: 2px;
      }
      &:active {
        border-radius: 2px;
      }
      .delete {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-color: transparent;
        background-image: url("../../assets/img/delete-icon.svg");
        background-size: 100% 100%;
        cursor: pointer;
        &:hover {
          border-radius: 2px;
          background-image: url("../../assets/img/delete-icon-hover.svg");
        }
      }
    }
  }
  
  /deep/ {
    .el-table td,
    .el-table th.is-leaf {
      border-bottom: 1px solid #f7f7fa;
    }
    .el-table th.is-leaf {
      border-bottom: 1px solid #f7f7fa;
    }
    .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #f7f8fc !important;
    }
    .el-table::before {
      background-color: #f7f7fa;
    }
    .delete-dialog {
      .el-dialog {
        background-color: #ffffff;
        border-radius: 0;
        width: 400px;
        height: 229px;
        position: relative;
        .el-dialog__headerbtn {
          top: 14px;
        }
        .el-dialog__header {
          padding: 0;
          height: 44px;
          width: 100%;
          box-shadow: inset 0px -1px 0px 0px #f7f7fa;
          padding: 0 24px;
          .el-dialog__title {
            color: #171f46;
            font-size: 14px;
            line-height: 44px;
          }
        }
        .el-dialog__body {
          padding: 24px;
          margin-top: 44px;
          color: #747990;
          font-size: 14px;
          line-height: 22px;
        }
        .el-dialog__footer {
          width: 100%;
          height: 64px;
          background-color: #ffffff;
          box-shadow: inset 0px 1px 0px 0px #f7f7fa;
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 16px 0;
          .footer-btn {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 136px;
            height: 32px;
            .cancel-btn {
              height: 32px;
              width: 60px;
              padding: 0;
              font-size: 14px;
              color: #464d6c;
              background-color: #f7f8fc;
              border-radius: 2px;
              border: none;
              &:hover {
                color: #464d6c;
                background-color: #eaebef;
              }
              &:focus {
                color: #464d6c;
                background-color: #eaebef;
              }
              &:active {
                color: #464d6c;
                background-color: #eaebef;
              }
            }
            .confirm-btn {
              height: 32px;
              width: 60px;
              padding: 0;
              font-size: 14px;
              color: #ffffff;
              background-color: #45a8cc;
              margin-left: 16px;
              border-radius: 2px;
              border: none;
              &:hover {
                color: #ffffff;
                background-color: #3e97b8;
              }
              &:focus {
                color: #ffffff;
                background-color: #3e97b8;
              }
              &:active {
                color: #ffffff;
                background-color: #3e97b8;
              }
            }
          }
        }
      }
    }
  }
  /deep/.filter-dialog {
  .dialog-selected {
    padding: 16px 24px;
    width: 100%;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .dialog-selected-title {
      color: #171f46;
      font-size: 14px;
    }
    .selected-tag {
      flex-wrap: wrap;
      .industry-tag {
        margin-right: 10px;
        margin-top: 10px;
        padding: 4px 8px;
        border-radius: 2px;
        border: solid 1px #45a8cc;
        color: #45a8cc;
        font-size: 12px;
        .del-img {
          margin-left: 4px;
          margin-top: 2px;
          width: 16px;
          height: 16px;
          background: url("../../assets/img/del-img.svg") no-repeat;
          background-size: cover; 
          cursor: pointer;
        }
      }
    }
  }
  .dialog-content {
    padding: 16px 24px;
    width: 100%;
    height: 248px;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .dialog-detail {
      flex-wrap: wrap;
      .dialog-detail-item {
        padding: 4px 8px;
        margin: 0 10px 10px 0;
        border-radius: 2px;
        border: 1px solid #e8e8e8;
        color: #464d6c;
        font-size: 12px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .industry-active {
        border: 1px solid #45a8cc;
        color: #45a8cc;
      }
    }
  }
  .dialog-footer {
    width: 100%;
    height: 64px;
    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 64px;
      .footer-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 130px;
        height: 32px;
        .cancel-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          border-radius: 2px;
          border: none;
          &:hover {
            color: #464d6c;
            background-color: #eaebef;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaebef;
          }
          &:active {
            color: #464d6c;
            background-color: #eaebef;
          }
        }
        .confirm-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          border-radius: 2px;
          border: none;
          font-weight: 500;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
      }
    }
  }
  .el-dialog {
    background-color: #ffffff;
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border: solid 1px #f7f7fa;
    border-radius: 0;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 290px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
.add-keywords-dialog {
    &_title {
      height: 44px;
      line-height: 44px;
      padding-left: 24px;
      font-size: 14px;
      color:#171f46;
      font-weight:500;
      background: #ffffff;
      box-shadow: inset 0px -1px 0px 0px #f7f7fa;
    }
    .keyword-news-list-box {
      padding-top: 10px;
      height: 436px;
      background: #ffffff;
      .add-keywords-input {
        padding:0 24px;
        height: 352px;
        overflow: auto;
        .add-keywords-input-title {
          margin-bottom: 6px;
          color: #464d6c;
          font-size: 12px;
          .mandatory-symbols {
            color: red;
          }
        }
        .add-keywords-input-content {
          position: relative;
          margin-bottom: 16px;
          /deep/ .el-input {
            width: 100%;
            height: 32px;
            border-radius: 2px;
            margin-top: 9px;
            .el-input__inner {
              height: 100%;
              border: none;
              background: #f7f8fc;
              color: #171f46;
              font-size: 14px;
              padding: 3px 12px;
            }
            .el-input__count .el-input__count-inner {
              background: #f7f8fc;
            }
            .el-input__inner::placeholder{
              color: #D1D2DA;
            }
            .el-input__inner::-webkit-input-placeholder{
              color: #D1D2DA;
            }
            .el-input__inner::-moz-placeholder{   /* Mozilla Firefox 19+ */
              color: #D1D2DA;
            }
            .el-input__inner:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
              color: #D1D2DA;
            }
            .el-input__inner:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
              color: #D1D2DA;
            }
          }
          input {
            width: 100%;
            height: 32px;
            padding: 10px 50px 10px 12px;
            font-size: 14px;
            border: solid 2px #f7f8fc;
            border-radius: 2px;
            background-color: #f7f8fc;
            outline: none;
          }
          input::-webkit-input-placeholder{
            color: #D1D2DA;
          }
          input::-moz-placeholder{   /* Mozilla Firefox 19+ */
            color: #D1D2DA;
          }
          input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
            color: #D1D2DA;
          }
          input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
            color: #D1D2DA;
          }
        }
        .add-keywords-textarea {
          position: relative;
          margin-bottom: 10px;
          .add-keywords-textarea-content {
            position: absolute;
            top: 7px;
            left: 12px;
            color: #9ea1b4;
            font-size: 12px;
          }
          .add-keywords-textarea-content-border {
            position: absolute;
            top: 7px;
            left: 96px;
            width: 1px;
            height: 16px;
            color: #e8e8ee;
            font-size: 12px;
          }
          /deep/ .el-textarea {
            .el-textarea__inner {
              padding: 5px 15px 5px 109px;
              color: #171f46 !important;
            }
            .el-textarea__inner::placeholder{
              color: #D1D2DA;
            }
            .el-textarea__inner::-webkit-input-placeholder{
              color: #D1D2DA;
            }
            .el-textarea__inner::-moz-placeholder{   /* Mozilla Firefox 19+ */
              color: #D1D2DA;
            }
            .el-textarea__inner:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
              color: #D1D2DA;
            }
            .el-textarea__inner:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
              color: #D1D2DA;
            }
          }
        }
      }
      .add-keywords-div {
        height: 10px;
        box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      }
      .add-keywords-btn {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        .cancel-add-keywords-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          font-weight: 400;
          &:hover {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:active {
            color: #464d6c;
            background-color: #eaeaed;
          }
        }
        .add-keywords-next-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          font-weight: 400;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
        .no-add-keywords-next-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: rgba(69, 168, 204, 0.4);
          font-weight: 400;
          cursor: auto;
          &:hover {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
          &:focus {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
          &:active {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
        }
      }
    }
    /deep/ .el-dialog__wrapper {
      .el-dialog {
        width: 480px;
        position: relative;
        border-radius: 8px;
        .el-dialog__header {
          position: absolute;
          top: 0;
          right: 0px;
          .el-dialog__headerbtn {
            width: 24px;
            height: 24px;
            top: 14px;
            .el-dialog__close {
              color: #514d4f;
            }
          }
        }
        .el-dialog__body {
          padding: 0;
          .el-textarea {
            .el-textarea__inner {
              margin-bottom: 0;
              background-color: #f7f8fc;
              border-radius: 2px;
              border: none;
              color: #747990;
            }
          }
        }
      }
    }
  }
  .pager {
    display: flex;
    justify-content: center;
    height: 46px;
    margin-top: 26px;
    & /deep/ {
      .el-pagination{
        .btn-prev,
        .btn-next,
        .el-pager .number,
        .el-pager li.btn-quicknext,
        .el-pager li.btn-quickprev,
        .el-icon-more .el-icon-d-arrow-right{
          border-radius:2px;
          border:1px solid rgba(229,230,238,1);
          background: #ffffff;
          min-width: 22px !important;
          height: 22px;
          line-height: 22px;
          font-size: 12px;
        }
        .active{
          border: none;
        }
        .more::before {
          line-height: 22px;
        }
        .el-pagination__jump{
          color: #747990;
          line-height: 22px;
        }
      }
      .el-pagination__editor.el-input .el-input__inner {
        height: 22px;
      }
    }
  }
</style>
